export default `
    <span class="label-link-container #= data.containerClasses || ""# #=data.bsc||""#">
        <span
              data-label-for-id="#= data.id #" class="bind-label #: data.classes || "" #"
             data-bind="#= data.bindLabel #"
        >
        </span>

        # if (data.rightLocked) { #
            <span
                id="#= data.id #"
                class="mar-r-20 bind-value #: data.valueClasses || "" #"
                data-bind="#= data.bindValue || "" #"
            >
        # } else { #
            <a
                id="#= data.id #" # if (data.disabled) { # disabled # } #
                class="link bind-value #: data.valueClasses || "" #"
                data-bind="#= data.bindValue || "" #"
                # if (data.toolTip) { #
                     title="#= data.toolTip #" 
                # } #
            >
            </a>
        # } #
    </span>
`;
